import { d as __extends } from './tslib.es6-4cb9af8a.js';
import { MemoryStorage } from './memoryStorage.js';
import { S as StorageService } from './_storageService-651e5a96.js';

var LocalStore = /** @class */ (function (_super) {
    __extends(LocalStore, _super);
    function LocalStore(storePrefix) {
        if (storePrefix === void 0) { storePrefix = null; }
        var _this = _super.call(this, storePrefix) || this;
        try {
            _this.storage = localStorage;
        }
        catch (e) {
            console.warn('Cannot get access to the localStorage, reason:', e);
            _this.storage = MemoryStorage();
        }
        return _this;
    }
    return LocalStore;
}(StorageService));
var localStore = new LocalStore();

export { LocalStore, localStore };
